export class EventsManagerBookingFormModule {

  constructor (element) {
    this.element = element;

    this.init();
  }

  init () {
    this.removeInputGroupClasses();
  }

  removeInputGroupClasses () {
    const targets = this.element.querySelectorAll('.input-group');

    targets.forEach(target => target.classList.remove('input-group'));
  }

}